import componentName from 'dc-vue-default/src/filters/componentName';
import boldNumbers from 'dc-vue-default/src/filters/boldNumbers';
import wrapInlineTables from './wrapInlineTables';
export default {
     install(Vue) {
         Vue.filter('componentName', componentName);
         Vue.filter('boldNumbers', boldNumbers);
         Vue.filter('wrapInlineTables', wrapInlineTables);
     }
}